import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ApuResourceApiModel } from "@/core/models/api/apu-resource-api.model";

export enum ApuResourceActionTypes {
  LoadApuResources = 'Load ApuResources',
  LoadApuResourceSuccess = 'Load ApuResource Success',
  LoadApuResourceFail = 'Load ApuResource Fail',
  AddApuResource = 'Add ApuResource',
  AddApuResourceSuccess = 'Add ApuResource Success',
  UpdateApuResource = 'Update ApuResource',
  UpdateApuResourceSuccess = 'Update ApuResource Success',
  DeleteApuResource = 'Delete ApuResource',
  ClearApuResources = 'Clear ApuResources',
  AddRangeApuResources = 'Add Range ApuResources',
  AddRangeApuResourceSuccess = 'Add Range ApuResource Success'
}

export const ApuResourceActions = createActionGroup({
  source: 'ApuResource',
  events: {
    [ApuResourceActionTypes.LoadApuResources]: emptyProps(),
    [ApuResourceActionTypes.LoadApuResourceSuccess]: props<{ apuResources: ApuResourceApiModel[] }>(),
    [ApuResourceActionTypes.LoadApuResourceFail]: props<{ error: string }>(),
    [ApuResourceActionTypes.AddApuResource]: props<{ apuResource: ApuResourceApiModel }>(),
    [ApuResourceActionTypes.AddApuResourceSuccess]: props<{ apuResource: ApuResourceApiModel }>(),
    [ApuResourceActionTypes.UpdateApuResource]: props<{ apuResource: ApuResourceApiModel }>(),
    [ApuResourceActionTypes.UpdateApuResourceSuccess]: props<{ apuResource: ApuResourceApiModel }>(),
    [ApuResourceActionTypes.DeleteApuResource]: props<{ apuResourceId: number }>(),
    [ApuResourceActionTypes.AddRangeApuResources]: props<{ apuResources: ApuResourceApiModel[] }>(),
    [ApuResourceActionTypes.AddRangeApuResourceSuccess]: props<{ apuResources: ApuResourceApiModel[] }>(),
    [ApuResourceActionTypes.ClearApuResources]: emptyProps(),
  }
});
